// AWS Amplify configuration
export const awsConfig = {
  Auth: {
    userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || '',
    userPoolWebClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID || '',
    mandatorySignIn: process.env.NEXT_PUBLIC_COGNITO_MANDATORY_SIGN_IN === 'true',
    authenticationFlowType: process.env.NEXT_PUBLIC_COGNITO_AUTH_FLOW_TYPE || 'USER_SRP_AUTH',
  },
  // Disable SSR
  ssr: false
};

// Validate configuration
if (!awsConfig.Auth.userPoolId || !awsConfig.Auth.userPoolWebClientId) {
  console.warn(
    'AWS Cognito configuration is missing. Please check your environment variables:',
    '\n- NEXT_PUBLIC_COGNITO_USER_POOL_ID',
    '\n- NEXT_PUBLIC_COGNITO_CLIENT_ID'
  );
}